import eventBus from "../eventBus";
import debounce from "@/utils/debounce";
import lazyImg from "@/assets/default.gif";
let images = [];

//处理单个image;
function setImage(image) {
  image.dom.src = lazyImg;
  const ClientHeight = document.documentElement.clientHeight;
  const rect = image.dom.getBoundingClientRect();
  if (rect.top <= ClientHeight && rect.top >= -120) {
    image.dom.src = image.src;
    images = images.filter((img) => img !== image);
  }
}

function handleScroll(dom) {
  for (var i = 0; i < images.length; i++) {
    setImage(images[i], dom);
  }
}

eventBus.$on("handleViewContainerScroll", debounce(handleScroll));
eventBus.$on("projectScroll", debounce(handleScroll));

export default {
  inserted(el, binding) {
    images.push({ dom: el, src: binding.value });
    handleScroll(el.dom); //页面渲染立即执行
  },
  unbind(el) {
    images = images.filter((image) => {
      image !== el;
    });
    eventBus.$off("handleViewContainerScroll", debounce(handleScroll)); //解绑时移除事件 源码无
    eventBus.$off("projectScroll", debounce(handleScroll));
  },
};
